var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame2147207310(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3432_9754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.91016 4.46875V13H3.7793V4.46875H4.91016ZM14.2793 4.46875V13H13.1426L8.84766 6.41992V13H7.7168V4.46875H8.84766L13.1602 11.0664V4.46875H14.2793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.70703 14.1719H15.2871V14.7578H2.70703V14.1719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("a", {
    href: "https://www.linkedin.com/in/karbet/"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillOpacity: 0,
    x: 2.70703,
    y: 1.96875,
    width: 12.5801,
    height: 14.0625
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3432_9754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7812 -0.00195312H4.21875C1.8888 -0.00195312 0 1.88685 0 4.2168V13.7793C0 16.1092 1.8888 17.998 4.21875 17.998H13.7812C16.1112 17.998 18 16.1092 18 13.7793V4.2168C18 1.88685 16.1112 -0.00195312 13.7812 -0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7812 -0.00195312H4.21875C1.8888 -0.00195312 0 1.88685 0 4.2168V13.7793C0 16.1092 1.8888 17.998 4.21875 17.998H13.7812C16.1112 17.998 18 16.1092 18 13.7793V4.2168C18 1.88685 16.1112 -0.00195312 13.7812 -0.00195312Z",
    fill: "#0A66C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9878 15.304H15.0458C15.1204 15.304 15.1919 15.2744 15.2447 15.2217C15.2974 15.1689 15.3271 15.0974 15.3271 15.0228L15.3281 10.6746C15.3281 8.40187 14.8384 6.65495 12.1825 6.65495C11.1729 6.61741 10.2208 7.13786 9.70699 8.00692C9.70448 8.01114 9.70066 8.01443 9.6961 8.01627C9.69155 8.01812 9.68652 8.01842 9.68178 8.01714C9.67704 8.01585 9.67285 8.01305 9.66984 8.00917C9.66684 8.00528 9.6652 8.00051 9.66516 7.9956V7.14602C9.66516 7.07142 9.63552 6.99989 9.58278 6.94714C9.53004 6.8944 9.4585 6.86477 9.38391 6.86477H7.43084C7.35624 6.86477 7.28471 6.8944 7.23196 6.94714C7.17922 6.99989 7.14959 7.07142 7.14959 7.14602V15.0224C7.14959 15.097 7.17922 15.1686 7.23196 15.2213C7.28471 15.274 7.35624 15.3037 7.43084 15.3037H9.48874C9.56333 15.3037 9.63487 15.274 9.68762 15.2213C9.74036 15.1686 9.76999 15.097 9.76999 15.0224V11.129C9.76999 10.0281 9.97882 8.96198 11.3437 8.96198C12.6891 8.96198 12.7065 10.2217 12.7065 11.2003V15.0228C12.7065 15.0974 12.7362 15.1689 12.7889 15.2216C12.8416 15.2744 12.9132 15.304 12.9878 15.304ZM2.67188 4.19064C2.67188 5.02483 3.35862 5.71122 4.19288 5.71122C5.02692 5.71115 5.71324 5.02434 5.71324 4.19029C5.7131 3.35624 5.02671 2.66992 4.19259 2.66992C3.35827 2.66992 2.67188 3.35645 2.67188 4.19064ZM3.16118 15.304H5.22183C5.29642 15.304 5.36796 15.2744 5.4207 15.2216C5.47345 15.1689 5.50308 15.0974 5.50308 15.0228V7.14602C5.50308 7.07142 5.47345 6.99989 5.4207 6.94714C5.36796 6.8944 5.29642 6.86477 5.22183 6.86477H3.16118C3.08659 6.86477 3.01505 6.8944 2.96231 6.94714C2.90956 6.99989 2.87993 7.07142 2.87993 7.14602V15.0228C2.87993 15.0974 2.90956 15.1689 2.96231 15.2216C3.01505 15.2744 3.08659 15.304 3.16118 15.304Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3432_9754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3432_9754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2147207310);
export default __webpack_public_path__ + "static/media/Frame 2147207310.9d6188b243285d1f50296dae66eaf091.svg";
export { ForwardRef as ReactComponent };